<template>
  <BaseModal
  :is-archivable="false"
  :is-editable="false"
  :is-visible="isMeetingModalVisible"
  :size="'lg'"
  @hideModal="hideModal()">
    <template #header>
      {{$t('buttons.addRelationNote')}}
    </template>
    <template #body>
      <EXCMRelationForm
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :id-firm="idFirm"
        :id-case="idCase"
        :id-organization-lead="idOrganizationLead"
        :errors="violations"/>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseModal from '@/components/BaseComponents/BaseModal'
import EXCMRelationForm from '../Form'
import CreateMixins from '@/components/Dashboard/Views/excmrelation/CreateMixins'

export default {
  name: 'MeetingCreateModal',
  components: {
    BaseModal,
    EXCMRelationForm
  },
  data () {
    return {
      item: {
        relationUserData: [],
        contactType: 1,
        idCategory: null
      }
    }
  },
  props: ['idCase', 'idFirm', 'idOrganizationLead'],
  mixins: [CreateMixins],
  created () {
    if (this.idCase) {
      this.item.idCase = this.idCase
    }
  },
  watch: {
    isMeetingModalVisible () {
      this.item = {
        relationUserData: [],
        contactType: 1,
        idCategory: null
      }
    }
  },
  computed: {
    ...mapGetters({
      created: 'excmrelation/create/created',
      violations: 'excmrelation/create/violations'
    })
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapMutations({
      setIsMeetingModalVisible: 'excmrelation/createModal/setIsMeetingModalVisible',
      toggleModal: 'excmrelation/createModal/toggleMeetingModal'
    }),
    ...mapActions({
      reset: 'excmrelation/create/reset',
      create: 'excmrelation/create/create'
    })
  }
}
</script>

<style scoped>

</style>
